var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16039_11084)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99988 13.7778C7.63169 13.7778 7.33322 13.4794 7.33322 13.1112L7.33322 4.49818L4.91576 6.91588C4.65542 7.17624 4.23331 7.17626 3.97295 6.91593C3.71258 6.65559 3.71256 6.23348 3.9729 5.97312L7.52846 2.41721C7.65348 2.29217 7.82306 2.22192 7.99988 2.22192C8.17671 2.22192 8.34629 2.29217 8.47131 2.41721L12.0269 5.97312C12.2872 6.23348 12.2872 6.65559 12.0268 6.91593C11.7665 7.17626 11.3443 7.17624 11.084 6.91588L8.66655 4.49818L8.66655 13.1112C8.66655 13.4794 8.36807 13.7778 7.99988 13.7778Z",
    fill: "#002CFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16039_11084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowUp);
export default __webpack_public_path__ + "static/media/iconArrowUp.bcd06fddbe4911f453366f7854fbee59.svg";
export { ForwardRef as ReactComponent };